<template>
  <layout name="Sidebar" extraClass="table-view-layout">
    <VTableView
      :sidebar="{
        buttons,
        title: 'Templates',
        extraClass: 'templates-layout-heading'
      }"
      :withPagination="
        (pagination.total_count > 25 && itemsPerPage > 25) ||
          pagination.page_count > 1
      "
    >
      <template slot="search">
        <LettersTemplatesSearch />
      </template>

      <template slot="table">
        <LettersTemplatesTable
          :items="templatesList"
          extraClass="templates-table-wrapper"
        ></LettersTemplatesTable>
      </template>

      <template slot="pagination">
        <LettersTemplatesPagination />
      </template>

      <template slot="extra">
        <TemplatesNewOneModal
          :opened="addTemplateIsOpened"
          @close="addTemplateIsOpened = false"
        >
        </TemplatesNewOneModal>
      </template>
    </VTableView>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import Layout from "@/layouts/Layout";

import VTableView from "@/views/VTableView";

// components
import VSidebarLayoutHeading from "@/components/VSidebarLayoutHeading";
import LettersTemplatesTable from "@/components/LettersTemplatesTable";
import TemplatesNewOneModal from "@/components/TemplatesNewOneModal";
import WithLoader from "@/components/WithLoader";
import LettersTemplatesSearch from "@/components/LettersTemplatesFilter";
import LettersTemplatesPagination from "@/components/LettersTemplatesPagination";

import withNavigate from "@/mixins/withNavigate";

export default Vue.component("Templates", {
  metaInfo: {
    title: "Templates"
  },

  components: {
    Layout,
    VSidebarLayoutHeading,
    LettersTemplatesTable,
    TemplatesNewOneModal,
    WithLoader,
    LettersTemplatesSearch,
    VTableView,
    LettersTemplatesPagination
  },

  mixins: [withNavigate],

  data() {
    return {
      addTemplateIsOpened: false,
      buttons: [
        {
          key: "new-template",
          type: "primary",
          label: "New Template",
          size: "regular",
          onClickHandler: () => (this.addTemplateIsOpened = true)
        }
      ]
    };
  },

  computed: {
    ...mapGetters("lettersTemplates", [
      "isLoading",
      "templatesList",
      "pagination",
      "search",
      "sort"
    ]),
    ...mapGetters("service", ["itemsPerPage"])
  },

  methods: {
    ...mapActions("lettersTemplates", ["fetchLettersTemplatesList"])
  },

  created() {
    this.fetchLettersTemplatesList({
      page: 1,
      sort: this.sort,
      search: this.search,
      page_size: this.pagination.page_size
    });
  }
});
</script>

<style lang="scss">
.templates-table-wrapper {
  @media screen and (max-width: 780px) {
    overflow: auto;
  }
}

.preview-text .v-editable-text__wrapper {
  margin-bottom: 0;
}
</style>
